import { render, staticRenderFns } from "./customizationProgram.vue?vue&type=template&id=2039bf7b"
import script from "./customizationProgram.vue?vue&type=script&lang=js"
export * from "./customizationProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports